import React from "react";

const Home = () => {
  return (
    <>
      <div className="hero border-1 pb-3">
        <div className="card bg-dark text-white border-0 mx-3">
          <img
            className="card-img img-fluid"
            src="./assets/main.jpeg"
            alt="Card"
            height={300}
          />
        </div>
      </div>
    </>
  );
};

export default Home;
